import { GoogleLogo, X } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";
import { ANON_LIMIT } from "@/lib/anonQuota";

/**
 * Modal shown when an anonymous browser has burned its 3 free fact-checks.
 * Blocks further submissions until sign-in.
 */
export default function FreeQuotaModal({ open, onClose }) {
  const { signIn } = useAuth();
  if (!open) return null;
  return (
    <div
      data-testid="free-quota-modal"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="relative w-full max-w-md border-2 border-black bg-white p-7 shadow-[8px_8px_0px_rgba(0,0,0,1)]">
        <button
          type="button"
          onClick={onClose}
          data-testid="free-quota-modal-close"
          aria-label="Close"
          className="absolute top-3 right-3 text-zinc-500 hover:text-zinc-950"
        >
          <X weight="bold" className="w-4 h-4" />
        </button>
        <div className="font-mono-plex text-[10px] font-semibold text-emerald-700 mb-3">
          FREE QUOTA REACHED · {ANON_LIMIT}/{ANON_LIMIT}
        </div>
        <h3 className="font-display text-3xl leading-tight text-zinc-950 mb-3">
          Sign in to keep fact-checking.
        </h3>
        <p className="text-[14px] text-zinc-700 leading-relaxed mb-6">
          You&apos;ve used your {ANON_LIMIT} free fact-checks in this browser. Sign in with Google
          — it takes one tap and it&apos;s free — to keep going. We only capture your email so we
          can raise your quota; nothing else.
        </p>
        <button
          type="button"
          onClick={signIn}
          data-testid="free-quota-modal-signin"
          className="w-full inline-flex items-center justify-center gap-2 bg-black text-white px-4 py-3 font-mono-plex text-[11px] font-semibold hover:bg-zinc-800 transition-colors"
        >
          <GoogleLogo weight="bold" className="w-4 h-4" />
          SIGN IN WITH GOOGLE
        </button>
        <button
          type="button"
          onClick={onClose}
          className="w-full mt-3 text-center font-mono-plex text-[10px] font-semibold text-zinc-500 hover:text-zinc-950"
        >
          Maybe later
        </button>
      </div>
    </div>
  );
}
